export const USER_WALLET_STATE = 'userWallet'

export const USER_WALLET_REQUEST = 'USER_WALLET_REQUEST'
export const USER_WALLET_SUCCESS = 'USER_WALLET_SUCCESS'
export const USER_WALLET_FAILED = 'USER_WALLET_FAILED'
